
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { RoutineHeader } from "../RoutineHeader";
import { ImageUploader } from "./ImageUploader";
import { DayLabel } from "./DayLabel";

interface RoutineItemHeaderProps {
  routine: {
    id: string;
    name: string;
    day: string;
  };
  refetchRoutines: () => void;
  onDelete: () => Promise<void>;
}

export const RoutineItemHeader = ({ 
  routine, 
  refetchRoutines, 
  onDelete 
}: RoutineItemHeaderProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [routineName, setRoutineName] = useState(routine.name);

  const handleUpdateName = async () => {
    try {
      const { error } = await supabase
        .from("routines")
        .update({ name: routineName })
        .eq("id", routine.id);

      if (error) {
        throw error;
      }

      toast({
        title: "Nombre actualizado",
        description: "El nombre de la rutina ha sido actualizado",
      });
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating routine name:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo actualizar el nombre de la rutina",
      });
    }
  };

  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex-1">
        <RoutineHeader
          name={routine.name}
          isEditing={isEditing}
          routineName={routineName}
          onEditStart={() => setIsEditing(true)}
          onEditCancel={() => {
            setIsEditing(false);
            setRoutineName(routine.name);
          }}
          onNameChange={setRoutineName}
          onUpdateName={handleUpdateName}
          onDelete={onDelete}
        />
        <DayLabel day={routine.day} />
      </div>
      <ImageUploader 
        routineId={routine.id} 
        refetchRoutines={refetchRoutines}
      />
    </div>
  );
};
